// src/pages/Login/Login.jsx

import React from 'react';
import { useLogin } from '../../hooks/useLogin';
import { FiMail, FiLock, FiLogIn, FiEye, FiEyeOff } from 'react-icons/fi';

const Login = () => {
    const {
        formData,
        errors,
        isLoading,
        showPassword,
        serverError,
        setShowPassword,
        handleChange,
        handleSubmit
    } = useLogin();

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-800 via-slate-900 to-gray-900 flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                {/* کارت اصلی با طراحی مدرن */}
                <div className="bg-white/10 backdrop-blur-xl rounded-3xl shadow-2xl p-8 border border-white/20">

                    {/* لوگو و عنوان */}
                    <div className="text-center mb-10">
                        <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-tr from-blue-500 to-blue-600 rounded-2xl shadow-lg mb-5">
                            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                            </svg>
                        </div>
                        <h1 className="text-3xl font-bold text-white mb-2">خوش آمدید</h1>
                        <p className="text-blue-200/80 text-sm">برای ورود اطلاعات خود را وارد کنید</p>
                    </div>

                    {/* خطای سرور */}
                    {serverError && (
                        <div className="mb-6 p-3 bg-red-500/20 backdrop-blur-sm rounded-xl border border-red-500/30">
                            <p className="text-red-200 text-sm text-center">{serverError}</p>
                        </div>
                    )}

                    {/* فرم لاگین */}
                    <form onSubmit={handleSubmit} className="space-y-5">

                        {/* فیلد ایمیل / نام کاربری */}
                        <div>
                            <div className="relative">
                                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                                    <FiMail className="text-gray-400" size={18} />
                                </div>
                                <input
                                    type="text"
                                    name="user_name"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="نام کاربری یا ایمیل"
                                    className={`w-full pl-11 pr-4 py-3.5 bg-white/10 backdrop-blur-sm rounded-xl text-white placeholder-gray-400 border focus:outline-none focus:ring-2 transition-all duration-200 ${
                                        errors.email || errors.user_name
                                            ? 'border-red-500 focus:ring-red-500'
                                            : 'border-white/30 focus:ring-blue-500 focus:border-transparent'
                                    }`}
                                    disabled={isLoading}
                                />
                            </div>
                            {(errors.email || errors.user_name) && (
                                <p className="mt-1 text-red-400 text-xs px-2">{errors.email || errors.user_name}</p>
                            )}
                        </div>

                        {/* فیلد رمز عبور */}
                        <div>
                            <div className="relative">
                                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                                    <FiLock className="text-gray-400" size={18} />
                                </div>
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    placeholder="رمز عبور"
                                    className={`w-full pl-11 pr-12 py-3.5 bg-white/10 backdrop-blur-sm rounded-xl text-white placeholder-gray-400 border focus:outline-none focus:ring-2 transition-all duration-200 ${
                                        errors.password
                                            ? 'border-red-500 focus:ring-red-500'
                                            : 'border-white/30 focus:ring-blue-500 focus:border-transparent'
                                    }`}
                                    disabled={isLoading}
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-gray-300 transition-colors"
                                >
                                    {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                                </button>
                            </div>
                            {errors.password && (
                                <p className="mt-1 text-red-400 text-xs px-2">{errors.password}</p>
                            )}
                        </div>

                        {/* دکمه ورود */}
                        <button
                            type="submit"
                            disabled={isLoading}
                            className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white font-semibold py-3.5 rounded-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-200 shadow-lg hover:shadow-xl disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2 mt-7"
                        >
                            {isLoading ? (
                                <>
                                    <svg className="animate-spin h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    <span>در حال ورود...</span>
                                </>
                            ) : (
                                <>
                                    <FiLogIn size={18} />
                                    <span>ورود به حساب</span>
                                </>
                            )}
                        </button>
                    </form>

                    {/* خط جداکننده */}
                    <div className="relative my-8">
                        <div className="absolute inset-0 flex items-center">
                            <div className="w-full border-t border-white/20"></div>
                        </div>
                        <div className="relative flex justify-center text-xs">
                            <span className="px-3 bg-transparent text-gray-400">ورود امن</span>
                        </div>
                    </div>

                    {/* نسخه اپلیکیشن */}
                    <div className="text-center">
                        <p className="text-gray-400 text-xs">
                            ورود شما به معنی پذیرش
                            <span className="text-blue-400"> قوانین و مقررات</span> است
                        </p>
                    </div>
                </div>

                {/* فوتر */}
                <div className="text-center mt-6">
                    <p className="text-gray-500 text-xs">
                        نسخه 2.0.0
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Login;